import { fetchClient } from "@/api/api";
import type {
	getAllTransferRecordsInput,
	getAllTransferRecordsOutput,
	getTransferRecordsFacetsOutput,
	getTransferRecordsPlayerFacetsInput,
	getTransferRecordsPlayerFacetsOutput,
} from "@/api/custom_types";
import { createFacetSource } from "@/services/facets";
import type { CustomQueryHook } from "@/utils/react-query";
import { useQuery } from "@tanstack/react-query";
import { TRANSFER_RECORDS_SERVICE_KEYS } from "./keys";

const useGetTransferRecords: CustomQueryHook<
	getAllTransferRecordsOutput,
	getAllTransferRecordsInput
> = (payload, options) => {
	return useQuery({
		...options,
		queryKey: TRANSFER_RECORDS_SERVICE_KEYS.useGetAllTransferRecords(payload),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET(
				"/v1/marketplace/transfer-records/",
				{ params: { query: payload?.query }, throwOnError: true },
			);
			if (error) throw error;
			return data;
		},
	});
};

/** Players need a label next to their id, so they have their own endpoint. */
const useGetTransferRecordsPlayerFacets: CustomQueryHook<
	getTransferRecordsPlayerFacetsOutput,
	getTransferRecordsPlayerFacetsInput
> = (payload, options) => {
	return useQuery({
		...options,
		queryKey:
			TRANSFER_RECORDS_SERVICE_KEYS.useGetTransferRecordsPlayerFacets(payload),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET(
				"/v1/marketplace/transfer-records/facets/players/",
				{ params: { query: payload?.query }, throwOnError: true },
			);
			if (error) throw error;
			return data;
		},
	});
};

const TRANSFER_RECORDS_FACET_SOURCE =
	createFacetSource<getTransferRecordsFacetsOutput>({
		path: "/v1/marketplace/transfer-records/facets/",
		queryKey: (payload) =>
			TRANSFER_RECORDS_SERVICE_KEYS.useGetTransferRecordsFacets(payload as any),
	});

export {
	TRANSFER_RECORDS_FACET_SOURCE,
	useGetTransferRecords,
	useGetTransferRecordsPlayerFacets,
};
